<div class="video-controls" role="group" [attr.aria-label]="'courses.video.controls' | translate">
  <button
    type="button"
    class="video-controls-button"
    [attr.aria-label]="
      (playing() ? 'courses.video.pause' : 'courses.video.play') | translate
    "
    [matTooltip]="
      (playing() ? 'courses.video.pause' : 'courses.video.play') | translate
    "
    (click)="togglePlay()"
  >
    <mat-icon>{{ playing() ? 'pause' : 'play_arrow' }}</mat-icon>
  </button>

  <span class="video-controls-time">
    {{ formatTime(currentTime()) }} / {{ formatTime(duration()) }}
  </span>

  <input
    type="range"
    class="video-controls-seek"
    min="0"
    max="100"
    step="0.1"
    [attr.aria-label]="'courses.video.seek' | translate"
    [value]="progressPercent"
    (input)="seekTo(+$any($event.target).value)"
  />

  <button
    type="button"
    class="video-controls-button"
    [attr.aria-label]="
      (muted() ? 'courses.video.unmute' : 'courses.video.mute') | translate
    "
    [matTooltip]="
      (muted() ? 'courses.video.unmute' : 'courses.video.mute') | translate
    "
    (click)="toggleMute()"
  >
    <mat-icon>{{ muted() ? 'volume_off' : 'volume_up' }}</mat-icon>
  </button>

  <input
    type="range"
    class="video-controls-volume"
    min="0"
    max="1"
    step="0.05"
    [attr.aria-label]="'courses.video.volume' | translate"
    [value]="muted() ? 0 : volume()"
    (input)="setVolume(+$any($event.target).value)"
  />

  <button
    type="button"
    class="video-controls-button video-controls-rate"
    [attr.aria-label]="'courses.video.playbackSpeed' | translate"
    [matTooltip]="'courses.video.playbackSpeed' | translate"
    [matMenuTriggerFor]="rateMenu"
  >
    <span class="video-controls-rate-value">{{ rate() }}x</span>
  </button>

  <mat-menu #rateMenu="matMenu">
    @for (option of availableRates; track option) {
      <button
        type="button"
        mat-menu-item
        [attr.aria-current]="rate() === option"
        (click)="setRate(option)"
      >
        <mat-icon>{{ rate() === option ? 'check' : '' }}</mat-icon>
        <span>{{ option }}x</span>
      </button>
    }
  </mat-menu>

  <button
    type="button"
    class="video-controls-button"
    [attr.aria-label]="'courses.video.fullscreen' | translate"
    [matTooltip]="'courses.video.fullscreen' | translate"
    (click)="toggleFullscreen()"
  >
    <mat-icon>fullscreen</mat-icon>
  </button>
</div>
